import { COMPANY } from "@/data/company";

const D = COMPANY.dominio;

export const localBusinessSchema = (areaServed = "Guarulhos") => ({
  "@context": "https://schema.org",
  "@type": "Plumber",
  "@id": `${D}/#localbusiness`,
  name: COMPANY.nome,
  legalName: COMPANY.razaoSocial,
  taxID: COMPANY.cnpj,
  url: D,
  telephone: COMPANY.telefoneRaw,
  image: `${D}/images/desentupidora-guarulhos-atendimento-24-horas.webp`,
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: COMPANY.endereco,
    addressLocality: COMPANY.cidade,
    addressRegion: COMPANY.estado,
    postalCode: COMPANY.cep,
    addressCountry: "BR",
  },
  geo: { "@type": "GeoCoordinates", latitude: COMPANY.geo.lat, longitude: COMPANY.geo.lng },
  areaServed: { "@type": "City", name: areaServed },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
  sameAs: [COMPANY.whatsapp],
  aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "387", bestRating: "5" },
});

export const serviceSchema = (name, description, url, area = "Guarulhos") => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name: `${name} em ${area}`,
  description,
  url: `${D}${url}`,
  provider: { "@id": `${D}/#localbusiness` },
  areaServed: { "@type": "Place", name: `${area}, Guarulhos - SP` },
  availableChannel: { "@type": "ServiceChannel", servicePhone: COMPANY.telefoneRaw, serviceUrl: COMPANY.whatsapp },
  hoursAvailable: "Mo-Su 00:00-23:59",
});

export const faqSchema = (faq) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faq.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${D}${it.url}`,
  })),
});
